var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { StepLayout } from './step-layout.component';
import { ChevronIcon } from './chevron-icon.component';
import { InformationToggle } from './information-toggle.component';
import { Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { AgeSelect } from 'hx-ui';
import { useFormContext } from 'react-hook-form';
import { palette } from '@/theme/palette';
import { useSendButtonClick } from '@/hooks/use-send-button-click.hook';
import { NavigationButton, NavigationButtonsContainer } from './navigation-button.component';
export function AgeSelectComponent() {
    var theme = useTheme();
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var getValues = useFormContext().getValues;
    var handleOpen = function () { return setIsOpen(true); };
    var handleClose = function () { return setIsOpen(false); };
    var birthYearValue = getValues('birth-year');
    var handleSendButtonClick = useSendButtonClick().handleSendButtonClick;
    return (_jsx(StepLayout, { image: pageImages.manSmilingAtPhone, progress: {
            step: 2,
            phase: 0,
        }, heading: _jsx(Typography, __assign({ variant: 'h2', className: 'md:pt-6 lg:pt-12 xl:pt-[72px] font-extrabold text-charcoal text-2xl lg:text-4xl' }, { children: "Select your birth year." })), content: _jsx("div", __assign({ className: "py-5" }, { children: _jsx(AgeSelect, { selectProps: {
                    label: 'Birth Year',
                    variant: 'standard',
                    className: 'min-w-[15em]',
                    sx: {
                        fontFamily: 'Inter, sans-serif',
                        color: palette.text.dark,
                        fontWeight: 700,
                        fontSize: !!birthYearValue ? '32px' : 'inherit',
                        '&.MuiInput-underline:before': {
                            borderColor: palette.primary.main
                        },
                        '&.MuiInput-underline:after': {
                            borderColor: palette.primary.main,
                        },
                        '& .MuiInputBase-root': {
                            backgroundColor: 'transparent !important',
                            '&.Mui-focused': {
                                backgroundColor: 'transparent',
                            },
                        },
                        '& .MuiSelect-select': {
                            backgroundColor: 'transparent !important',
                        },
                    },
                    customIcon: function (props) { return _jsx(ChevronIcon, __assign({}, props, { isOpen: isOpen })); },
                    handleOpen: handleOpen,
                    handleClose: handleClose,
                }, modal: {
                    config: {
                        buttonProps: {
                            className: 'bg-primary py-2 md:w-full md:max-w-[200px]',
                            text: 'Close'
                        },
                        modalProps: {
                            className: 'gap-0 pt-10 pb-12'
                        }
                    },
                    message: 'This hearing test is designed for users 18 and up.'
                } }) })), info: _jsx(InformationToggle, __assign({ title: "Why we ask", chevronColor: theme.palette.primary.main, onClick: function () { return handleSendButtonClick('why_ask_my_age'); } }, { children: _jsx(Typography, { children: "This test is for adults 18 and older. Hearing changes over time, and knowing your age helps us give you the most accurate results." }) })), nav: _jsxs(NavigationButtonsContainer, __assign({ className: 'mb-6' }, { children: [_jsx(NavigationButton, { type: "back", variant: "outlined", label: "Previous" }), _jsx(NavigationButton, { type: "submit", variant: "contained", label: "Next" })] })) }));
}
